import makeStyles from '@mui/styles/makeStyles';

// istanbul ignore next
export const useStyles = makeStyles((theme) => ({
    root: {
        border: '1px solid #E5E8EB',
        height: 'fit-content',
        padding: theme.spacing(4),
    },
}));
